/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { MktuClassWord } from './MktuClassWord'
import {
  MktuClassWordFromJSON,
  MktuClassWordFromJSONTyped,
  MktuClassWordToJSON,
} from './MktuClassWord'

/**
 *
 * @export
 * @interface GetSuggestedWord200Response
 */
export interface GetSuggestedWord200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetSuggestedWord200Response
   */
  status: boolean
  /**
   *
   * @type {Array<MktuClassWord>}
   * @memberof GetSuggestedWord200Response
   */
  data: Array<MktuClassWord>
}

/**
 * Check if a given object implements the GetSuggestedWord200Response interface.
 */
export function instanceOfGetSuggestedWord200Response(
  value: object
): value is GetSuggestedWord200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetSuggestedWord200ResponseFromJSON(
  json: any
): GetSuggestedWord200Response {
  return GetSuggestedWord200ResponseFromJSONTyped(json, false)
}

export function GetSuggestedWord200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetSuggestedWord200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: (json['data'] as Array<any>).map(MktuClassWordFromJSON),
  }
}

export function GetSuggestedWord200ResponseToJSON(
  value?: GetSuggestedWord200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: (value['data'] as Array<any>).map(MktuClassWordToJSON),
  }
}
